"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zustand_1 = __importDefault(require("zustand"));
const middleware_1 = require("zustand/middleware");
const zustand_async_storage_1 = require("./zustand_async_storage");
const createPersistStorage = (name, initializer) => ((0, zustand_1.default)()((0, middleware_1.persist)(initializer, {
    name: name,
    getStorage: () => zustand_async_storage_1.ZustandAsyncStorage // (optional) by default the 'localStorage' is used
})));
exports.default = createPersistStorage;
//# sourceMappingURL=createPersistStorage.js.map